<template>
  <v-form id="filters-form">
    <v-card>
      <v-container fluid wrap class="py-1" color="white">
        <v-row>
          <v-col cols="12">
            <v-menu
              :close-on-content-click="false"
              :nudge-width="400"
              offset-x
              v-if="location_schema"
            >
              <template v-slot:activator="{ on }">
                <v-btn
                  rounded
                  class="mr-2 mb-2"
                  color="primary"
                  outlined
                  small
                  v-on="on"
                >{{location_schema.value ? location_schema.value.formatted_address : location_schema.title}}</v-btn>
              </template>

              <v-card>
                <v-container>
                  <input-factory
                    :config="location_schema"
                    @updateNeeded="loadSchema"
                    @input="updateQuery"
                  ></input-factory>
                </v-container>
              </v-card>
            </v-menu>

            <v-menu bottom>
              <template v-slot:activator="{ on }">
                <v-btn
                  rounded
                  small
                  color="primary"
                  :outlined="!current_sort"
                  v-on="on"
                  class="mr-2 mb-2"
                >
                  {{current_sort ? current_sort.title: 'Sort By'}}
                  <v-icon right>mdi-chevron-down</v-icon>
                </v-btn>
              </template>

              <v-list dense>
                <v-list-item
                  v-for="(item, index) in sort_variants"
                  :key="index"
                  @click="()=>updateQuery(item.value)"
                >
                  <v-list-item-title>{{ item.title }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
            <v-btn
              rounded
              color="primary"
              :outlined="!filters_count"
              class="mr-2 mb-2"
              small
              @click="() => { expanded = !expanded }"
            >
              <span>
                {{ trans('search.filters_title', null, 'filters') }}
                <v-avatar
                  v-if="filters_count"
                  left
                  class="primary darken-2"
                  size="20"
                >{{filters_count}}</v-avatar>
              </span>
            </v-btn>
            <input-factory :config="date_schema" @updateNeeded="loadSchema" @input="updateQuery"></input-factory>
            <v-menu :close-on-content-click="false" :nudge-width="400" offset-x v-if="price_schema">
              <template v-slot:activator="{ on }">
                <v-btn
                  rounded
                  small
                  class="mr-2 mb-2"
                  color="primary"
                  :outlined="!price_value"
                  v-on="on"
                >{{price_label}}</v-btn>
              </template>

              <v-card>
                <v-container>
                  <input-factory
                    :config="price_schema"
                    @updateNeeded="loadSchema"
                    @input="updateQuery"
                  ></input-factory>
                </v-container>
              </v-card>
            </v-menu>

            <!-- <v-btn
            :block="this.$vuetify.breakpoint.xsOnly"
            color="primary"
            class="ml-2"
            @click="() => { expanded_date = !expanded_date }"
          >
            <span>date</span>
            </v-btn>-->
            <v-btn
              rounded
              color="orange"
              outlined
              small
              class="mb-2 ml-auto"
              @click="showSaveSearchForm"
            >
              <v-icon left>mdi-bell</v-icon>
              {{ trans('search.save_search_criteria', null, 'Save Alert') }}
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-card>

    <v-dialog v-model="expanded" max-width="760" scrollable>
      <v-card>
        <v-card-text class="pl-0 pr-0">
          <v-tabs vertical class="tab-divider">
            <template v-for="(group,i) in filtered_group" v-show="(i < 1 || i >= 1 && expanded)">
              <v-tab :key="i+group.title">
                <div style="width: 100%" class="text-left">{{group.title}}</div>
              </v-tab>
              <v-tab-item :key="i">
                <v-row no-gutters class="pt-3 px-2">
                  <input-factory
                    class="my-1"
                    v-for="(config, index) in group.inputs"
                    :key="config.id"
                    :config="config"
                    @updateNeeded="loadSchema"
                    @input="updateQuery"
                    @filterTextUpdate="updateFilter"
                    @filterTextRemove="removeFilter"
                  ></input-factory>
                </v-row>
              </v-tab-item>
            </template>
            <template
              v-for="(config,id,i) in filtered_schema"
              v-show="(i < 1 || i >= 1 && expanded)"
            >
              <v-tab :key="id">
                <div style="width: 100%" class="text-left">{{config.title}}</div>
              </v-tab>
              <v-tab-item :key="id">
                <v-row no-gutters class="pt-3 px-2">
                  <input-factory
                    :config="config"
                    @updateNeeded="loadSchema"
                    @input="updateQuery"
                    @filterTextUpdate="updateFilter"
                    @filterTextRemove="removeFilter"
                  ></input-factory>
                </v-row>
              </v-tab-item>
            </template>
          </v-tabs>
        </v-card-text>
        <v-card-actions class="blue-grey lighten-5 d-flex flex-wrap" v-if="filters.length > 0">
          <v-chip
            @click:close="handleFilterRemove(filter.id)"
            class="mx-1 mb-1"
            color="primary"
            close
            v-for="(filter,id) in filters"
            :key="id"
          >{{filter.title}}: {{filter.value}}</v-chip>
        </v-card-actions>
        <v-card-actions>
          <v-btn
            small
            color="primary"
            class="mr-auto"
            v-if="filters.length > 0"
            @click="handleReset"
          >Reset All</v-btn>
          <v-btn small color="primary" class="ml-auto" @click="() => expanded = false">Done</v-btn>
        </v-card-actions>
        <!-- <v-container
          fluid
          grid-list-xl
          v-for="schema,id,i in schema_grouped"
          v-show="(i < 1 || i >= 1 && expanded)"
          :key="i"
        >
          <v-row>
            <input-factory
              v-for="config,key in schema"
              :key="key"
              :config="config"
              @updateNeeded="loadSchema"
              @input="updateQuery"
            ></input-factory>
          </v-row>
        </v-container>-->
      </v-card>
    </v-dialog>

    <v-container fluid v-if="show_save_form && authenticated">
      <v-form v-model="valid">
        <v-card>
          <!-- <v-card-text v-if="saved_searches">
            <v-list>
              <v-list-item two-line v-for="(saved_search,s) in saved_searches" :key="s">
                <v-list-item-content>
                  <v-list-item-title>{{ saved_search.title }}</v-list-item-title>
                  <v-list-item-subtitle>
                    {{ saved_search.property_type }} in
                    {{ saved_search.formatted_address }}
                  </v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action>
                  <v-list-item-action-text>{{ moment(saved_search.created_at) }}</v-list-item-action-text>
                  <v-flex>
                    <v-btn text @click="loadSearch(saved_search.uuid)">{{ trans('search.search') }}</v-btn>
                    <v-btn
                      text
                      v-if="saved_search.subscription"
                      @click="unsubscribeSearch(saved_search.uuid)"
                    >{{ trans('search.unsubscribe') }}</v-btn>
                    <v-btn
                      text
                      v-if="!saved_search.subscription"
                      @click="subscribeSearch(saved_search.uuid)"
                    >{{ trans('search.subscribe') }}</v-btn>
                    <v-btn
                      text
                      color="error"
                      @click="deleteSearch(saved_search.uuid)"
                    >{{ trans('search.delete') }}</v-btn>
                  </v-flex>
                </v-list-item-action>
              </v-list-item>
            </v-list>
          </v-card-text>-->

          <v-divider v-if="saved_searches"></v-divider>

          <v-card-text>
            <v-text-field
              v-model="saved_search_instance.title"
              :label="trans('search.title')"
              :placeholder="trans('search.title_placeholder')"
              :rules="[ v => !!v || 'Field is required']"
              hide-details
              outlined
            ></v-text-field>

            <!-- <v-checkbox
              v-model="saved_search_instance.subscription"
              :label="trans('search.subscription_check')"
            ></v-checkbox>-->
          </v-card-text>
          <v-card-actions>
            <v-btn
              color="secondary"
              outlined
              @click="show_save_form = false"
            >{{ trans('app.cancel') }}</v-btn>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              :disabled="!valid"
              :loading="search_saving"
              @click="saveSearchCriteria"
            >{{ trans('search.save_search_criteria') }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-container>
  </v-form>
</template>

<script>
import _ from "lodash";
import { mapGetters, mapActions, mapState } from "vuex";
import EventBus from "../event_bus";

export default {
  data: () => ({
    autocomplete: null,
    expanded: false,
    expanded_date: false,
    show_save_form: false,
    property_types: [
      {
        text: "Room",
        value: "room",
      },
      {
        text: "Apartment",
        value: "apartment",
      },
    ],

    // temp
    saved_search_instance: {
      title: null,
      subscription: true,
    },
    valid: false,
  }),

  computed: {
    ...mapState("search", {
      query: "query",
      _schema: "schema",
      filters: "filters",
    }),
    ...mapGetters("search", {
      isLoading: "isLoading",
      filterValue: "filterValue",
    }),
    ...mapState("auth", {
      authenticated: "authenticated",
    }),
    ...mapState("saved-search", {
      search_saving: "instance_saving",
      saved_searches_pagination: "pagination",
    }),

    saved_searches: function () {
      return _.get(this.saved_searches_pagination, "data", null);
    },

    schemaIsLoading: function () {
      return this.isLoading("schema");
    },

    schema_grouped: function () {
      let fieldset = {};
      for (let i in this.schema) {
        let fieldset_id = this.schema[i].group;
        if (!fieldset[fieldset_id]) fieldset[fieldset_id] = [];
        fieldset[fieldset_id].push(this.schema[i]);
      }
      return fieldset;
    },
    price_value() {
      const price_val = this.filterValue("price");
      if (!price_val || (!price_val.min && !price_val.max)) {
        return null;
      }
      return true;
    },
    price_label() {
      const price_val = this.filterValue("price");
      if (!price_val || (!price_val.min && !price_val.max)) {
        return this.price_schema.title;
      }

      let result = "";
      if (price_val.max && price_val.min) {
        result = price_val.min + " - " + price_val.max;
        return result + " $";
      }
      if (price_val.max) result = "to " + price_val.max;
      if (price_val.min) result = "from " + price_val.min;
      return result + " $";
    },

    // returns only filters
    filtered_schema(condition) {
      let schema = Object.assign({}, _.cloneDeep(this._schema));
      const noInclude = [
        "flatmate_smoking",
        "flatmate_gender",
        "flatmate_occupation",
        "flatmate_age_min",
        "flatmate_age_max",
        "bills_included",
        "amenities",
        "facilities",
        "available_from",
        "price",
        "location",
        "price_currency",
        "property_type",
        "occupants",
        "rent_term",
        "minimum_rent_months",
        "spoken_language",
        "has_media",
      ];

      return _.pickBy(schema, (value, key) => {
        schema[key].size = { cols: 12 };
        // to get data from store

        schema[key].value = this.filterValue(key);
        return !noInclude.includes(key);
      });
    },
    filtered_group() {
      let schema = Object.assign({}, _.cloneDeep(this._schema));
      schema["property_type"].is_list = true;
      schema["occupants"].is_list = true;
      let result = [
        {
          title: "Property Type",
          inputs: _.pick(schema, ["property_type"]),
        },
        {
          title: "Property options",
          inputs: _.pick(schema, [
            "bills_included",
            "rent_term",

            this.filterValue("rent_term") == "month"
              ? "minimum_rent_months"
              : null,
            "amenities",
            "facilities",
          ]),
        },
        { title: "Number Of People", inputs: _.pick(schema, ["occupants"]) },
        {
          title: "Flatmate",
          inputs: _.pick(schema, [
            "flatmate_smoking",
            "flatmate_gender",
            "flatmate_occupation",
            "flatmate_age_min",
            "flatmate_age_max",
          ]),
        },
        {
          title: "Photos",
          inputs: _.pick(schema, ["has_media"]),
        },
        {
          title: "Landlord's spoken language",
          inputs: _.pick(schema, ["spoken_language"]),
        },
      ];
      result.forEach((item) => {
        _.forEach(item.inputs, (__, key) => {
          item.inputs[key].value = this.filterValue(key);
        });
      });
      return result;
    },
    //count of selected filters
    filters_count() {
      if (this.filters.length == 0) return null;
      return this.filters.length;
    },
    //return only search location input
    location_schema() {
      let schema = Object.assign({}, _.cloneDeep(this._schema));
      schema["location"].size = { cols: 12 };
      return schema["location"];
    },
    //return only date input
    date_schema() {
      let schema = Object.assign({}, _.cloneDeep(this._schema));
      schema["available_from"].is_btn = true;

      schema["available_from"].is_inline = true;

      schema["available_from"].value = this.filterValue("available_from");
      return schema["available_from"];
    },
    // sort options
    sort_variants() {
      return [
        {
          title: "Recommended",
          value: { order_by: "rating", dir: "desc" },
        },
        {
          title: "Most Recent",
          value: { order_by: "created_at", dir: "desc" },
        },
        {
          title: "Lowest Price",
          value: { order_by: "price", dir: "desc" },
        },
        {
          title: "Highest Price",
          value: { order_by: "price", dir: "asc" },
        },
      ];
    },
    current_sort() {
      const curr_order = _.get(this.query, "order_by", null);
      const curr_dir = _.get(this.query, "dir", null);
      if (curr_order) {
        const sort = this.sort_variants.find((item) =>
          _.isEqual(item.value, { order_by: curr_order, dir: curr_dir })
        );
        return sort;
      }
      return null;
    },
    //price inout config
    price_schema() {
      let schema = Object.assign({}, this._schema);
      if (!schema["price"]) return null;
      schema["price"].is_btn = true;

      // inline option
      schema["price"].is_inline = true;
      return schema["price"];
    },
    schema: function () {
      let schema = Object.assign({}, this.filtered_schema);

      return _.map(schema, (config) => {
        if (config.id == "location") {
          config.size = { cols: 12 };
        }
        if (
          config.id == "available_from" ||
          config.id == "property_type" ||
          config.id == "occupants"
        ) {
          config.size = { cols: 12, sm: 4 };
        }
        if (
          config.id == "amenities" ||
          config.id == "facilities" ||
          config.id == "from_agent" ||
          config.id == "has_media" ||
          config.id == "bills_included"
        ) {
          config.size = { cols: 12, sm: 12 };
        }
        if (config.id == "price") {
          config.size = { cols: 12 };
        }
        if (config.id == "price_currency") {
          config.size = { cols: 2, sm: 2 };
        }
        return config;
      });
    },
  },

  mounted: function () {
    this.loadSchema();
  },

  methods: {
    ...mapActions("search", {
      fetch: "fetch",
      setQuery: "setQuery",
      setQueryParam: "setQueryParam",
      resetQuery: "resetQuery",
      resetFilters: "resetFilters",
      loadSchema: "loadSchema",
      updateFilter: "updateFilter",
      removeFilter: "removeFilter",
    }),

    ...mapActions("saved-search", {
      updateSearchInstance: "updateInstance",
      storeSearch: "store",
      fetchSearches: "fetch",
      subscribe: "subscribe",
      unsubscribe: "unsubscribe",
      delete: "delete",
    }),

    onPlaceChanged: function (place) {
      let data = {
        address_components: _.get(place, "address_components", []),
        formatted_address: _.get(place, "formatted_address"),
        geometry: {
          location: _.get(place, "geometry.location").toJSON(),
          viewport: _.get(place, "geometry.viewport").toJSON(),
        },
        place_id: _.get(place, "place_id"),
        // zoom: zoom
      };
      this.location = Object.assign(
        {},
        data,
        _.get(place, "geometry.viewport").toJSON()
      );
    },

    updateQuery: function (param) {
      // this.setQueryParam(param);
      this.$emit("update", param);
      // this.submit();
      // console.log(this.query);
    },
    handleFilterRemove(id) {
      this.removeFilter(id);
      let param = {};
      param[id] = null;
      this.$emit("update", param);
    },
    handleReset() {
      let params = {};
      this.filters.forEach((item) => {
        params[item.id] = null;
      });
      this.resetFilters();
      //this.resetQuery();
      this.$emit("update", params);
    },
    showSaveSearchForm: function () {
      if (this.show_save_form == true) {
        this.show_save_form = false;
        return;
      }
      if (!this.authenticated) {
        EventBus.$emit("requiresAuth", null);
        return;
      }
      //   this.fetchSearches();
      this.show_save_form = true;
    },

    saveSearchCriteria: function () {
      if (!this.authenticated) {
        EventBus.$emit("requiresAuth", null);
        return;
      }

      let bugfix = {
        price_currency: "usd",
      };
      let payload = Object.assign(
        {},
        this.query,
        this.saved_search_instance,
        bugfix
      );
      this.updateSearchInstance(payload);

      let p = this.storeSearch();
      p.then(() => {
        this.fetchSearches();
      });
    },

    unsubscribeSearch: function (uuid) {
      let p = this.unsubscribe(uuid);
      p.then(() => {
        this.fetchSearches();
      });
    },

    subscribeSearch: function (uuid) {
      let p = this.subscribe(uuid);
      p.then(() => {
        this.fetchSearches();
      });
    },

    deleteSearch: function (uuid) {
      let p = this.delete(uuid);
      p.then(() => {
        this.fetchSearches();
      });
    },

    loadSearch: function (uuid) {
      let search = _.find(this.saved_searches, (e) => e.uuid == uuid);
      let query = Object.assign({}, search);
      let location = _.pick(query, [
        "formatted_address",
        "lat",
        "lng",
        "east",
        "north",
        "south",
        "west",
        "place_id",
      ]);

      // let price_query = {
      // 	price: {
      // 		min: _.get(query, 'price_min', null),
      // 		max: _.get(query, 'price_max', null)
      // 	}
      // }

      query = _.omit(query, [
        "uuid",
        "created_by",
        "created_at",
        "updated_at",
        "deleted_at",
        "title",

        "formatted_address",
        "lat",
        "lng",
        "east",
        "north",
        "south",
        "west",
        "place_id",

        "country",
        "postal_code",
        "route",
        "state",
        "street_number",
        "sublocality",
        "subscription",
      ]);

      query = _.omitBy(query, (e) => e == null);

      query = Object.assign(query, /*price_query,*/ { location: location });
      this.resetQuery();
      this.setQueryParam(query);

      this.$emit("update", query);

      // console.log(JSON.stringify(query, null, 2));

      this.loadSchema();

      this.fetch();
    },
  },
};
</script>
<style lang="scss">
.tab-divider {
  & .v-tabs-bar {
    border-right: 1px solid #bdbdbd;
  }
  & .v-tabs-slider {
    width: 4px;
  }
}
</style>